const urlRoot = "https://www.comp.nus.edu.sg/~dbsystem"

export default (slug) =>
  slug == null ? null : `${urlRoot}/${slug.replace(/^\//, "")}`
